import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/client';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) return { companyName: 'FARMAVIDA', isFarmavida: true };
  return context;
};

export const TenantProvider = ({ children }) => {
  const [tenantInfo, setTenantInfo] = useState({
    companyName: 'FARMAVIDA',
    isFarmavida: true,
    plan: 'enterprise'
  });

  useEffect(() => {
    const fetchTenantInfo = async () => {
      try {
        const token = localStorage.getItem('farmavida_token');
        if (!token) return;
        const res = await apiClient.get('/tenant/info');
        setTenantInfo({
          companyName: res.data.company_name || 'FARMAVIDA',
          isFarmavida: res.data.is_farmavida,
          plan: res.data.plan
        });
      } catch (e) {}
    };
    fetchTenantInfo();
  }, []);

  return (
    <TenantContext.Provider value={tenantInfo}>
      {children}
    </TenantContext.Provider>
  );
};

export default TenantContext;
